const routeNames = {
  AUTH: {
    PATH: '/',
    NAME: 'authorization'
  },
  HOME: {
    PATH: '/',
    NAME: 'authorization'
  },
  ABOUT: {
    PATH: '/about',
    NAME: 'about'
  },
  TERMSOFSERVICE: {
    PATH: '/terms-of-service',
    NAME: 'termsofservice'
  },
  ADDFAMILY: {
    PATH: '/addfamily',
    NAME: 'addfamily'
  },
  PROFILE: {
    PATH: '/profile',
    NAME: 'profile'
  },
  FAMILYLIST: {
    PATH: '/familylist',
    NAME: 'familylist'
  },
  ADMIN: {
    PATH: '/admin',
    NAME: 'admin'
  },
  ADMINORGS: {
    PATH: '/admin/organizations',
    NAME: 'adminorganizations'
  },
  ADMINUSERS: {
    PATH: '/admin/users/',
    NAME: 'adminusers'
  },
  ADMINUSERSBYORG: {
    PATH: '/admin/users/:id',
    NAME: 'adminusersbyorg'
  },
  ADMINDUPLICATES: {
    PATH: '/admin/duplicates',
    NAME: 'adminduplicates'
  }
}

export default routeNames;
